module.exports = __webpack_public_path__ + "media/newstyle/images/icon-person-white-ee60b3756d017ea4d708a006b2821f12.svg";